import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputDisplayComponent  } from '../input-display/input-display.component';
import { SkeletonModule } from 'primeng/skeleton';

interface DisplayValue {
  label?: string;
  value?: string;
  valueComponent?: string | null;
}

@Component({
  selector: 'app-input-display-grid',
  standalone: true,
  imports: [CommonModule, InputDisplayComponent, SkeletonModule],
  templateUrl: './input-display-grid.component.html',
  styleUrls: ['./input-display-grid.component.scss'],
})
export class InputDisplayGridComponent {
  @Input() values: DisplayValue[] = [];
  @Input() columnLength = 1;
  @Input() includeMargin = false;
  @Input() loading = false;


  get rows(): DisplayValue[][] {
    const rows: DisplayValue[][] = [];
    for (let i = 0; i < this.values.length; i += this.columnLength) {
      rows.push(this.values.slice(i, i + this.columnLength));
    }
    return rows;
  }
}
